<!-- Common page header: page title on top, breadcrumb navigation below it.
     Rendered once by the layout for every screen (full.component.html). -->
<div class="page-breadcrumb app-page-header p-t-20 p-b-20 p-l-30 p-r-30">
    <h4 class="page-title text-themecolor m-0">{{pageInfo?.title}}</h4>

    <nav aria-label="breadcrumb" class="app-page-trail" *ngIf="trail.length">
        <ol class="trail-list">
            <li class="trail-item">
                <a routerLink="/" class="trail-link">
                    <mat-icon class="trail-icon">home</mat-icon>
                    <span>Home</span>
                </a>
            </li>
            <li class="trail-item" *ngFor="let crumb of trail; let last = last" [class.active]="last">
                <mat-icon class="trail-separator">chevron_right</mat-icon>
                <a *ngIf="!last" [routerLink]="crumb.url" class="trail-link">
                    <span>{{crumb.label}}</span>
                </a>
                <span *ngIf="last" class="trail-current">{{crumb.label}}</span>
            </li>
        </ol>
    </nav>

    <!-- Template (apps/) routes describe their trail with data.urls instead. -->
    <div class="breadcrumb d-flex align-items-center" *ngIf="!trail.length && pageInfo?.urls?.length">
        <ul class="list-style-none d-flex align-items-center">
            <ng-template ngFor let-url [ngForOf]="pageInfo?.urls" let-last="last">
                <li class="breadcrumb-item" *ngIf="!last" [routerLink]="url.url">
                    <a [routerLink]='url.url'>{{url.title}}</a>
                </li>
                <li class="breadcrumb-item active" *ngIf="last">{{url.title}}</li>
            </ng-template>
        </ul>
    </div>
</div>
